module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('div', {
    staticClass: "text-left"
  }, [_c('h5', [_vm._v("套用門市")]), _vm._v(" "), _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      key: ("storeClass-" + index),
      staticClass: "m-r-5 m-b-10 inline-block"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_vm._v("\n          " + _vm._s(storeClass.name) + "\n        ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-left"
  }, [_vm._v("參與店家")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.copySetting
    }
  }, [_vm._v("\n      確定\n    ")])]), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("複製此分店所有設定至其他店家")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27751d78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/CopyStoreTemp.vue
// module id = 2354
// module chunks = 1